module.exports = function(h, row) {
    let remark;

    if (row.void_remarks) {
        remark = row.void_remarks;
    } else {
        remark = row.reason;
    }

    if (remark == 'Abort Fuel') {
        return <span class="italic">{remark}</span>;
    }

    return <span>{remark.substring(0, 20)}</span>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/voided/void-remarks.jsx